exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinner{width:2em;height:2em;border-radius:100%;border:1px solid hsla(0,0%,100%,.2);border-left-color:#fff;-webkit-animation:load 1.1s infinite linear;animation:load 1.1s infinite linear}@-webkit-keyframes load{0%{-ms-transform:rotate(7deg);-webkit-transform:rotate(7deg);transform:rotate(7deg)}to{-ms-transform:rotate(1turn);-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes load{0%{-ms-transform:rotate(7deg);-webkit-transform:rotate(7deg);transform:rotate(7deg)}to{-ms-transform:rotate(1turn);-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/dtts/dtts.scss
// module id = 1070
// module chunks = 0